var React = require('react');

function ProductsIcon44Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_60","data-name":"Obszar roboczy 60","transform":"translate(-11.142 -5.88)"},[React.createElement("path",{"id":"Path_400","data-name":"Path 400","d":"M12.12,10.61a10.876,10.876,0,0,1,15.76,0","fill":"none","stroke":"#000","strokeWidth":"2.7","key":0}),React.createElement("path",{"id":"Path_401","data-name":"Path 401","d":"M15.83,14.67a5.416,5.416,0,0,1,8.34,0","fill":"none","stroke":"#000","strokeWidth":"2.7","key":1}),React.createElement("path",{"id":"Path_402","data-name":"Path 402","d":"M16.34,34.34H13.18L18.1,19.06h3.57l4.92,15.28H23.3l-1-3.44H17.35l-1.02,3.44Zm1.87-6.33h3.27l-1.61-5.6Z","fill":"#1d1d1b","key":2})]));
}

ProductsIcon44Inline.defaultProps = {"width":"17.716","height":"28.46","viewBox":"0 0 17.716 28.46"};

module.exports = ProductsIcon44Inline;

ProductsIcon44Inline.default = ProductsIcon44Inline;
